import { TreeDataNode } from 'core-ui';
import { PermissionList } from 'src/enums/permission';
import { RoutePath } from 'src/enums/routePath';

export const PERMISSIONS = {
  [PermissionList.PAYMENT_MANAGER_LIST]: '決済管理',
  [PermissionList.SUBMIT_AGREEMENT_LIST]: '同意書一覧',
  [PermissionList.SUBMIT_AGREEMENT_CREATE]: '同意書新規作成',
  [PermissionList.SUBMIT_AGREEMENT_EDIT]: '同意書編集',
  [PermissionList.SUBMIT_AGREEMENT_DELETE]: '同意書削除',
  [PermissionList.SUBMIT_AGREEMENT_SEARCH_LIST]: '同意書検索',
  [PermissionList.CUSTOMER_LIST]: '契約情報一覧',
  [PermissionList.CUSTOMER_IMPORT_CSV]: 'CSVインポート',
  [PermissionList.CUSTOMER_EXPORT_CSV]: 'CSVエクスポート',
  [PermissionList.CUSTOMER_SEARCH_LIST]: '契約情報検索',
  [PermissionList.CUSTOMER_CREATE]: '契約情報新規作成',
  [PermissionList.CUSTOMER_DETAIL]: '契約情報詳細',
  [PermissionList.CUSTOMER_EDIT]: '契約情報編集',
  [PermissionList.CUSTOMER_DELETE]: '契約情報削除',
  [PermissionList.CLIENT_LIST]: '会員情報一覧',
  [PermissionList.CLIENT_IMPORT_CSV]: 'CSVインポート',
  [PermissionList.CLIENT_EXPORT_CSV]: 'CSVエクスポート',
  [PermissionList.CLIENT_SEARCH_LIST]: '会員情報検索',
  [PermissionList.CLIENT_CREATE]: '会員情報新規作成',
  [PermissionList.CLIENT_DETAIL]: '会員情報詳細',
  [PermissionList.CLIENT_EDIT]: '会員情報編集',
  [PermissionList.CLIENT_DELETE]: '会員情報削除',
  [PermissionList.REPAIR_LIST]: '修理一覧',
  [PermissionList.REPAIR_CREATE]: '修理新規作成',
  [PermissionList.REPAIR_DETAIL]: '修理詳細',
  [PermissionList.REPAIR_EDIT]: '修理編集',
  [PermissionList.REPAIR_DELETE]: '修理削除',
  [PermissionList.ACCOUNT_LIST]: 'アカウント管理',
  [PermissionList.ACCOUNT_CREATE]: 'アカウント新規作成',
  [PermissionList.ACCOUNT_DETAIL]: 'アカウント詳細',
  [PermissionList.ACCOUNT_EDIT]: 'アカウント編集',
  [PermissionList.ACCOUNT_DELETE]: 'アカウント削除',
  [PermissionList.PERMISSION_LIST]: '役割一覧',
  [PermissionList.PERMISSION_CREATE]: '役割新規作成',
  [PermissionList.PERMISSION_EDIT]: '役割編集',
  [PermissionList.PERMISSION_DELETE]: '役割削除',
  [PermissionList.ENABLING_REPAIR_AGREEMENT_LINK]: '全般設定',
  [PermissionList.MAKER_LIST]: 'メーカー名一覧',
  [PermissionList.MAKER_CREATE]: 'メーカー名新規作成',
  [PermissionList.MAKER_EDIT]: 'メーカー名編集',
  [PermissionList.MAKER_DELETE]: 'メーカー名削除',
  [PermissionList.MODEL_LIST]: '型番一覧',
  [PermissionList.MODEL_CREATE]: '型番新規作成',
  [PermissionList.MODEL_EDIT]: '型番編集',
  [PermissionList.MODEL_DELETE]: '型番削除',
  [PermissionList.CATEGORY_LIST]: '製品カテゴリー一覧',
  [PermissionList.CATEGORY_CREATE]: '製品カテゴリー新規作成',
  [PermissionList.CATEGORY_EDIT]: '製品カテゴリー編集',
  [PermissionList.CATEGORY_DELETE]: '製品カテゴリー削除',
  [PermissionList.PLAN_LIST]: 'プラン一覧',
  [PermissionList.PLAN_CREATE]: 'プラン新規作成',
  [PermissionList.PLAN_DETAIL]: 'プラン詳細',
  [PermissionList.PLAN_EDIT]: 'プラン編集',
  [PermissionList.PLAN_DELETE]: 'プラン削除',
  [PermissionList.IMEI_CREATE]: 'IMEI情報取得新規作成',
  [PermissionList.IMEI_EDIT]: 'IMEI情報取得編集',
  [PermissionList.AGENCY_LIST]: '代理店一覧',
  [PermissionList.AGENCY_CREATE]: '代理店新規作成',
  [PermissionList.AGENCY_DETAIL]: '代理店詳細',
  [PermissionList.AGENCY_EDIT]: '代理店編集',
  [PermissionList.AGENCY_DELETE]: '代理店削除',
  [PermissionList.AGENCY_INHERITED_PLAN_ADD]:
    '販売プラン（傘下代理店対象）プラン追加',
  [PermissionList.AGENCY_INHERITED_PLAN_DELETE]:
    '販売プラン（傘下代理店対象）プラン削除',
  [PermissionList.AGENCY_EXCLUDED_PLAN_ADD]:
    '販売プラン（傘下代理店非対象）プラン追加',
  [PermissionList.AGENCY_EXCLUDED_PLAN_DELETE]:
    '販売プラン（傘下代理店非対象）プラン削除',
  [PermissionList.AGENCY_AUTHORITY_LIST]: '代理店権限設定一覧',
  [PermissionList.AGENCY_AUTHORITY_EDIT]: '代理店権限設定編集',
  [PermissionList.AGENCY_AUTHORITY_DETAIL]: '代理店権限設定詳細',
  [PermissionList.AGENCY_AUTHORITY_APPROVED]: '代理店権限設定承認',
  [PermissionList.QR_REGISTER_LIST]: '申込用QRコード管理一覧',
  [PermissionList.QR_REGISTER_CREATE]: '申込用QRコード新規作成',
  [PermissionList.QR_REGISTER_DELETE]: '申込用QRコード削除',
  [PermissionList.SALES_MANAGER_LIST]: '売上管理一覧',
  [PermissionList.SALES_MANAGER_EXPORT_CSV]: 'CSVエクスポート',
  [PermissionList.COUNT_CALLS_LIST]: '入電件数・応答件数閲覧のみ',
  [PermissionList.COUNT_CALLS_CREATE]: '入電件数・応答件数新規作成',
  [PermissionList.COUNT_CALLS_EDIT]: '入電件数・応答件数編集',
  [PermissionList.COUNT_CALLS_DELETE]: '入電件数・応答件数削除',
  [PermissionList.COUNT_REPAIRS_LIST]: '修理件数閲覧のみ',
  [PermissionList.COUNT_REPAIRS_CREATE]: '修理件数新規作成',
  [PermissionList.COUNT_REPAIRS_EDIT]: '修理件数編集',
  [PermissionList.COUNT_REPAIRS_DELETE]: '修理件数削除',
  [PermissionList.MAIL_PLAN_COMPLETE_DETAIL]: '申込完了メール詳細',
  [PermissionList.MAIL_PLAN_COMPLETE_EDIT]: '申込完了メール編集',
  [PermissionList.MAIL_LOGIN_DETAIL]: 'マイページ情報メール詳細',
  [PermissionList.MAIL_LOGIN_EDIT]: 'マイページ情報メール編集',
  [PermissionList.MAIL_PAYMENT_SUCCESS_DETAIL]: '決済成功メール詳細',
  [PermissionList.MAIL_PAYMENT_SUCCESS_EDIT]: '決済成功メール編集',
  [PermissionList.MAIL_PAYMENT_FAIL_DETAIL]: '決済失敗メール詳細',
  [PermissionList.MAIL_PAYMENT_FAIL_EDIT]: '決済失敗メール編集',
  [PermissionList.TEST_SEND_MAIL]: 'メール送信テスト'
};
export const PERMISSION_FIRST_LOGIN_PATH = {
  [PermissionList.PAYMENT_MANAGER_LIST]: RoutePath.ADMIN + RoutePath.PAYMENTS,
  [PermissionList.SUBMIT_AGREEMENT_LIST]:
    RoutePath.ADMIN + RoutePath.INSURANCE_APPLICATION,
  [PermissionList.SUBMIT_AGREEMENT_SEARCH_LIST]: '',
  [PermissionList.SUBMIT_AGREEMENT_CREATE]:
    RoutePath.ADMIN + RoutePath.INSURANCE_APPLICATION,
  [PermissionList.SUBMIT_AGREEMENT_EDIT]:
    RoutePath.ADMIN + RoutePath.INSURANCE_APPLICATION,
  [PermissionList.SUBMIT_AGREEMENT_DELETE]:
    RoutePath.ADMIN + RoutePath.INSURANCE_APPLICATION,
  [PermissionList.CUSTOMER_LIST]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_IMPORT_CSV]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_EXPORT_CSV]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_CREATE]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_DETAIL]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_EDIT]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_DELETE]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CUSTOMER_SEARCH_LIST]: RoutePath.ADMIN + RoutePath.CUSTOMERS,
  [PermissionList.CLIENT_LIST]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_IMPORT_CSV]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_EXPORT_CSV]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_CREATE]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_DETAIL]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_EDIT]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_DELETE]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.CLIENT_SEARCH_LIST]: RoutePath.ADMIN + RoutePath.CLIENTS,
  [PermissionList.REPAIR_LIST]: RoutePath.REPAIRS,
  [PermissionList.REPAIR_CREATE]: RoutePath.REPAIRS,
  [PermissionList.REPAIR_DETAIL]: RoutePath.REPAIRS,
  [PermissionList.REPAIR_EDIT]: RoutePath.REPAIRS,
  [PermissionList.REPAIR_DELETE]: RoutePath.REPAIRS,
  [PermissionList.ACCOUNT_LIST]: RoutePath.ADMIN + RoutePath.ACCOUNT,
  [PermissionList.ACCOUNT_CREATE]: RoutePath.ADMIN + RoutePath.ACCOUNT,
  [PermissionList.ACCOUNT_DETAIL]: RoutePath.ADMIN + RoutePath.ACCOUNT,
  [PermissionList.ACCOUNT_EDIT]: RoutePath.ADMIN + RoutePath.ACCOUNT,
  [PermissionList.ACCOUNT_DELETE]: RoutePath.ADMIN + RoutePath.ACCOUNT,
  [PermissionList.PERMISSION_LIST]: RoutePath.ADMIN + RoutePath.CONFIG,
  [PermissionList.PERMISSION_CREATE]: RoutePath.ADMIN + RoutePath.CONFIG,
  [PermissionList.PERMISSION_EDIT]: RoutePath.ADMIN + RoutePath.CONFIG,
  [PermissionList.PERMISSION_DELETE]: RoutePath.ADMIN + RoutePath.CONFIG,
  [PermissionList.ENABLING_REPAIR_AGREEMENT_LINK]:
    RoutePath.ADMIN + RoutePath.CONFIG + RoutePath.EXPIRATION,
  [PermissionList.MAKER_LIST]: RoutePath.ADMIN + RoutePath.MAKERS,
  [PermissionList.MAKER_CREATE]: RoutePath.ADMIN + RoutePath.MAKERS,
  [PermissionList.MAKER_EDIT]: RoutePath.ADMIN + RoutePath.MAKERS,
  [PermissionList.MAKER_DELETE]: RoutePath.ADMIN + RoutePath.MAKERS,
  [PermissionList.MODEL_LIST]: RoutePath.ADMIN + RoutePath.MODELS,
  [PermissionList.MODEL_CREATE]: RoutePath.ADMIN + RoutePath.MODELS,
  [PermissionList.MODEL_EDIT]: RoutePath.ADMIN + RoutePath.MODELS,
  [PermissionList.MODEL_DELETE]: RoutePath.ADMIN + RoutePath.MODELS,
  [PermissionList.CATEGORY_LIST]: RoutePath.ADMIN + RoutePath.PRODUCTS,
  [PermissionList.CATEGORY_CREATE]: RoutePath.ADMIN + RoutePath.PRODUCTS,
  [PermissionList.CATEGORY_EDIT]: RoutePath.ADMIN + RoutePath.PRODUCTS,
  [PermissionList.CATEGORY_DELETE]: RoutePath.ADMIN + RoutePath.PRODUCTS,
  [PermissionList.PLAN_LIST]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.PLAN_CREATE]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.PLAN_DETAIL]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.PLAN_EDIT]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.PLAN_DELETE]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.IMEI_CREATE]: RoutePath.ADMIN + RoutePath.IMEI,
  [PermissionList.IMEI_EDIT]: RoutePath.ADMIN + RoutePath.IMEI,
  [PermissionList.AGENCY_LIST]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_CREATE]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_DETAIL]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_EDIT]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_DELETE]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_INHERITED_PLAN_ADD]:
    RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_INHERITED_PLAN_DELETE]:
    RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_EXCLUDED_PLAN_ADD]: RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_EXCLUDED_PLAN_DELETE]:
    RoutePath.ADMIN + RoutePath.AGENCY,
  [PermissionList.AGENCY_AUTHORITY_LIST]:
    RoutePath.ADMIN + RoutePath.AGENCY_AUTHORITY,
  [PermissionList.AGENCY_AUTHORITY_EDIT]:
    RoutePath.ADMIN + RoutePath.AGENCY_AUTHORITY,
  [PermissionList.AGENCY_AUTHORITY_DETAIL]:
    RoutePath.ADMIN + RoutePath.AGENCY_AUTHORITY,
  [PermissionList.AGENCY_AUTHORITY_APPROVED]:
    RoutePath.ADMIN + RoutePath.AGENCY_AUTHORITY,
  [PermissionList.QR_REGISTER_LIST]: RoutePath.ADMIN + RoutePath.QR_CODE,
  [PermissionList.QR_REGISTER_CREATE]: RoutePath.ADMIN + RoutePath.QR_CODE,
  [PermissionList.QR_REGISTER_DELETE]: RoutePath.ADMIN + RoutePath.QR_CODE,
  [PermissionList.SALES_MANAGER_LIST]: RoutePath.ADMIN + RoutePath.SALES,
  [PermissionList.SALES_MANAGER_EXPORT_CSV]: RoutePath.ADMIN + RoutePath.SALES,
  [PermissionList.COUNT_CALLS_LIST]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_CALLS_CREATE]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_CALLS_EDIT]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_CALLS_DELETE]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_REPAIRS_LIST]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_REPAIRS_CREATE]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_REPAIRS_EDIT]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.COUNT_REPAIRS_DELETE]:
    RoutePath.ADMIN + RoutePath.COUNT_SETTING_NUMBER,
  [PermissionList.MAIL_LOGIN_DETAIL]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_LOGIN_EDIT]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PLAN_COMPLETE_DETAIL]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PLAN_COMPLETE_EDIT]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PAYMENT_SUCCESS_DETAIL]:
    RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PAYMENT_SUCCESS_EDIT]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PAYMENT_FAIL_DETAIL]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.MAIL_PAYMENT_FAIL_EDIT]: RoutePath.ADMIN + RoutePath.PLANS,
  [PermissionList.TEST_SEND_MAIL]: RoutePath.ADMIN + RoutePath.PLANS
};
export const getAllNodes = (treeData: TreeDataNode[]) => {
  const result: TreeDataNode[] = [];

  const traverse = (node: TreeDataNode) => {
    result.push({ title: node.title, key: node.key });
    if (node.children) {
      node.children.forEach(traverse);
    }
  };

  treeData.forEach(traverse);
  return result;
};
